import React, { useContext } from 'react';
import { FormattedMessage, IntlContext } from 'react-intl';
import { useFormikContext } from 'formik';
import { TextFieldWithLabel, SelectFieldWithLabel } from '../../../../components/FormFields';
import { constants } from '../../../../constants'
import AppContext from '../../../../components/AppContext';

export default function ContactInfoTabBody() {
	const appContext = useContext(AppContext);
	const { values, isSubmitting, submitCount, errors } = useFormikContext();
	
	const { messages } = useContext(IntlContext);

	const {countries, provinces, states, mexicanStates, preferredLanguages} = appContext.codeTables;
	const disableOnSubmit = (submitCount !== 0 && isSubmitting && (!errors || Object.keys(errors).length === 0));

	// Commenting out because this is MidTier responsibility to arrange Countries order.
	// function sortAsc(arr, field) {
	// 	return arr.sort((a, b) => (a[field] > b[field] ? 1 : b[field] > a[field] ? -1 : 0));
	// }
	
	let filteredCountries = countries.filter(country => country.label !== "Unknown")
	// sortAsc(filteredCountries, 'label');
	let filteredStates = states.filter(state => state.label !== "Unknown")

	return (
		<>
		  <div className="form-group col-md-12 text-left row-magic">
		    <h2 class="h3"><FormattedMessage id="sima.account.accountInfo.title" /></h2>
		    <p>
		      <span className="label label-info"><b><FormattedMessage id="wet.note"/><FormattedMessage id="wet.colon"/></b></span> 
		      &nbsp;<FormattedMessage id="contact.noteParagraph.modificationWarning" />{messages["sima.account.accountInfo.URN.title"]}
		    </p>
		  </div>
		  <div className="form-group col-md-12 text-left row-magic">
		    <TextFieldWithLabel id="ace_urn" name="ace_urn" disabled={true} maxLength="8" label={messages["sima.account.accountInfo.URN.label"]} title={messages["sima.account.accountInfo.URN.title"]} />
		    <TextFieldWithLabel id="firstname" name="firstname" required={true} maxLength="200" label={messages["sima.account.accountInfo.firstName"]}/>
		    <TextFieldWithLabel id="lastname" name="lastname" required={true} maxLength="200" label={messages["sima.account.accountInfo.lastName"]}/>
		    <TextFieldWithLabel id="emailaddress1" name="emailaddress1" disabled={true} maxLength="200" label={messages["sima.account.accountInfo.email"]}/>
		    <TextFieldWithLabel id="address" name="address" required={true} maxLength="200" label={messages["sima.account.accountInfo.companyAddress.label"]}/>
		    <TextFieldWithLabel id="city" name="city" required={true} maxLength="200" label={messages["sima.account.accountInfo.companyCity.label"]}/>
		    <SelectFieldWithLabel id="country" name="country" disabled={disableOnSubmit}  required={true} label={messages["common.country"]}
		      options={[
		      	{value:"", label: messages["common.select..."]}
		      	, ...filteredCountries
		      ]}
		    />
		    {values["country"] ? 
		    	<>
		    	  {values["country"] === constants.countries["Canada"] ?
		    	  	<SelectFieldWithLabel id="provinceState" name="provinceState" disabled={disableOnSubmit}  required={true} label={messages["common.provinceState"]}
		    	  	  options={[
		    	  	    {value:"", label: messages["common.select..."]}
		    	  	    , ...provinces
		    	  	  ]}
		    	  	/>
		    	  :
		    	  	values["country"] === constants.countries["United States"] ?
		    	  		<SelectFieldWithLabel id="provinceState" name="provinceState" disabled={disableOnSubmit}  required={true} label={messages["common.provinceState"]}
		    	  		  options={[
		    	  		  	{value:"", label: messages["common.select..."]}
		    	  		  	, ...filteredStates
		    	  		  ]}
		    	  		/>
		    	  	: 
		    	  		values["country"] === constants.countries["Mexico"] ?
		    	  			<SelectFieldWithLabel id="provinceState" name="provinceState" disabled={disableOnSubmit}  required={true} label={messages["common.provinceState"]}
		    	  			  options={[
		    	  			  	{value:"", label: messages["common.select..."]}
		    	  			  	, ...mexicanStates
		    	  			  ]}
		    	  			/>
		    	  		: <TextFieldWithLabel id="provinceStateOther" name="provinceStateOther" disabled={disableOnSubmit} maxLength="100" label={messages["common.provinceState"]}/>
		    	  }
		    	</>
		    : <></>
		    }
		    <TextFieldWithLabel id="postalZipCode" name="postalZipCode" disabled={disableOnSubmit}  placeholder={values["country"] === constants.countries["Canada"] ? messages["common.postalCodeZipCode.postalExample"] : values["country"] === constants.countries["United States"] ? messages["common.postalCodeZipCode.zipExample"] : ""} required={(values["country"] === constants.countries["Canada"] || values["country"] === constants.countries["United States"]) ? true : false} maxLength="20" label={messages["common.postalCodeZipCode"]}/>
		    <SelectFieldWithLabel id="languagePreference" name="languagePreference" disabled={disableOnSubmit}  required={true} label={messages["common.preferredLanguage"]}
		      options={[
		      	{value:"", label: messages["common.select..."]}
		      	, ...preferredLanguages
		      ]}
		    />
		  </div>
		</>
	);
}
